import { ChatOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

import IntellioAdvantageChatDrawer from '../../components/DealGPT/IntellioAdvantageChatDrawer';
import { useDrawer } from '../../components/Providers/DrawerProvider';
import { useFetchData } from '../../hooks/useFetchData';
import { ProjectWithLastScanned, SummarizationFile } from '../../Types/dealGPT';
import { ChatMode, IndexType } from '../../Types/enums';
import { summaryChatFilesPathUrl } from '../../util/routesUrls';

interface ChatIconButtonProps {
  project: ProjectWithLastScanned;
  mode: ChatMode;
  currentCollectionId?: string;
  scope?: string;
  pageName?: string;
}

const ChatIconButton: React.FC<ChatIconButtonProps> = ({
  project,
  mode,
  currentCollectionId,
  scope,
  pageName,
}) => {
  const { openDrawer } = useDrawer();

  // Backend will return files ONLY for that collection or scope/page.
  const { data: summaryFiles } = useFetchData<SummarizationFile[]>({
    urlPath: summaryChatFilesPathUrl(project.id, undefined, currentCollectionId, scope, pageName),
  });

  // Hide focused chat for Graph RAG projects and when no summary files are available.
  if (project.indexToUse === IndexType.GRAPH_RAG || !summaryFiles || summaryFiles.length === 0) {
    return null;
  }

  const handleOpenChatDrawer = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    const initialSelectedSumaryFileId =
      summaryFiles.find((f) => f.scope === scope && f.pageName === pageName)?.id ??
      summaryFiles[0].id;

    openDrawer({
      anchor: 'right',
      header: 'Focused Chat',
      content: (
        <IntellioAdvantageChatDrawer
          project={project}
          initialMode={mode}
          initialSummaryFileId={initialSelectedSumaryFileId}
        />
      ),
    });
  };

  return (
    <Tooltip title={`Open Focused Chat`}>
      <IconButton size="small" onClick={handleOpenChatDrawer}>
        <ChatOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default ChatIconButton;
